import validationMessages from '@/utils/validation'

const validationMixin = {
  methods: {
    getValidationErrors (model) {
      let alertErrors = []
      let lang = this.$i18n.locale

      if (this.$v[model] === undefined) {
        console.error('CIR: Model is undefined. Check if you define it right as getValidationErrors(???) parameter.')
        return false
      }

      Object.keys(this.$v[model].$params).map((fieldName) => {
        // Go through old params
        Object.keys(this.$v[model][fieldName].$params).map((rule) => {
          if (!this.$v[model][fieldName][rule]) {
            // WIP
            let ruleParams = this.$v[model][fieldName].$params[rule]
            delete ruleParams.type
            //

            let message = ''
            // If custom message exist
            if (validationMessages[lang].custom[model] && validationMessages[lang].custom[model][fieldName]) {
              if (validationMessages[lang].custom[model][fieldName][rule]) {
                message = validationMessages[lang].custom[model][fieldName][rule]
              }
              // Else get a global message
            } else if (validationMessages[lang].global[rule]) {
              // TODO Replace min and max
              let replace = validationMessages[lang].attributes[model + '.' + fieldName] || fieldName
              message = validationMessages[lang].global[rule].replace('{field}', replace)
            } else {
              console.error('CIR: Validation message for "' + rule + '" rule does not exist.')
            }

            alertErrors.push({
              type: rule,
              msg: message
            })
          }
        })
      })
      return alertErrors
    }
  }
}

export { validationMixin }



// WEBPACK FOOTER //
// ./src/mixins/validation.js